import React, { useState, useEffect } from 'react';
import styles from './Settings.module.css';
import UsersManagement from './UsersManagement.tsx';
import CustomersManagement from './CustomersManagement.tsx';
import IngredientsManagement from './IngredientsManagement';
import VendorsManagement from './VendorsManagement';
import RoleBasedAccess from './RoleBasedAccess.tsx';
import useAuth from '../hooks/useAuth.ts';

const Settings = () => {
  const { auth } = useAuth();
  const [activeTab, setActiveTab] = useState('users');
  
  // Set default tab based on user role
  useEffect(() => {
    if (auth.user && auth.user.role === 'Editor') {
      // Editors can't access users tab, so default to customers
      setActiveTab('customers');
    }
  }, [auth.user]);

  return (
    <div className={styles.settingsContainer}>
      <div className={styles.settingsHeader}>
        <h1 className={styles.settingsTitle}>Settings</h1>
      </div>
      
      <div className={styles.tabsContainer}>
        <div className={styles.tabs}>
          <RoleBasedAccess allowedRoles={['Manager']}>
            <button 
              className={`${styles.tabButton} ${activeTab === 'users' ? styles.activeTab : ''}`}
              onClick={() => setActiveTab('users')}
            >
              Users
            </button>
          </RoleBasedAccess>
          <button 
            className={`${styles.tabButton} ${activeTab === 'customers' ? styles.activeTab : ''}`}
            onClick={() => setActiveTab('customers')}
          >
            Customers
          </button>
          <button 
            className={`${styles.tabButton} ${activeTab === 'vendors' ? styles.activeTab : ''}`}
            onClick={() => setActiveTab('vendors')}
          >
            Vendors
          </button>
          <button 
            className={`${styles.tabButton} ${activeTab === 'ingredients' ? styles.activeTab : ''}`}
            onClick={() => setActiveTab('ingredients')}
          >
            Ingredients
          </button>
        </div>
      </div>
      
      <div className={styles.settingsContent}>
        {activeTab === 'users' && (
          <RoleBasedAccess allowedRoles={['Manager']}>
            <UsersManagement />
          </RoleBasedAccess>
        )}
        {activeTab === 'customers' && <CustomersManagement />}
        {activeTab === 'ingredients' && <IngredientsManagement />}
        {activeTab === 'vendors' && <VendorsManagement />}
      </div>
    </div>
  );
};

export default Settings;
